import { API_PATHS } from "../constants/api-paths";
import { API_STATUS_CODE } from "../constants/util";
import { logErrorToNewRelic } from "../utils/logging";
import { request } from "../core/api.client";

export interface ICompanyDetails {
  data: {
    businessName: string;
    pan: string;
    address: string;
    entityType: string;
    natureOfBusiness: string;
    pincode: string;
    departmentCode: string;
    registrationType: string;
    registrationDate: string;
  };
}

export interface IHsnDetails {
  data: {
    hsnCode: string;
    name: string;
    description: string;
    igst: string;
  }[];
  statusCode: number;
  message: string;
}

export const getCompanyDetails = async (gstin: string) => {
  const response = await request<ICompanyDetails>({
    method: "POST",
    url: API_PATHS.gstCompanyDetails,
    data: {
      gstin,
    },
  });

  if (
    response.statusCode !== API_STATUS_CODE.success &&
    response.statusCode !== API_STATUS_CODE.noData
  ) {
    logErrorToNewRelic(response.message);
    throw new Error(response.message);
  }

  return response;
};

export const getHsnDetails = async () => {
  const response: IHsnDetails = await request({
    method: "GET",
    url: API_PATHS.hsnDetails,
  });
  if (
    response.statusCode !== API_STATUS_CODE.success &&
    response.statusCode !== API_STATUS_CODE.noData
  ) {
    logErrorToNewRelic(response.message);
    throw new Error(response.message);
  }

  return response;
};
